import React from "react"
import PropTypes from "prop-types"
import Radium from "higher-order-components/configured-radium/"
import { H5 } from "AtomicComponents"

import SummaryItem from "./item"


function Summary({
  heading = "",
  previousGeneration,
  items = [],
  disableBase = false,
  ruleBelowHeading,
  children,
  horizontalLayout = false
}) {
  return (
    <div style={[!disableBase && styles.base(horizontalLayout)]} data-test="summary">
      {heading && <H5 withDetails>{heading}</H5>}
      {ruleBelowHeading && <hr style={styles.hr} />}
      {previousGeneration && (
        <div style={{ fontWeight: 200, marginTop: "1em" }}>Previous Model</div>
      )}
      {items
        .filter(Boolean)
        .map(({ ruleAfter, ...props }, index) => (
          <div key={index} style={{ flexGrow: "1", padding: horizontalLayout ? "1em" : "" }}>
            <SummaryItem {...props} />
            {ruleAfter && <hr style={[styles.hr, { margin: "2em 0 1em" }]} />}
          </div>
        ))
      }
      {children}
    </div>
  )
}

Summary.propTypes = {
  heading: PropTypes.string,
  previousGeneration: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape(SummaryItem.propTypes)
  ),
  ruleBelowHeading: PropTypes.bool,
  priceTemplate: PropTypes.func,
  disableBase: PropTypes.bool
}

export default Radium(Summary)

const styles = {
  base: horizontalLayout => ({
    display: horizontalLayout ? "flex" : "block",
    maxWidth: horizontalLayout ? "100%" : "350px",
    margin: "auto",
    width: horizontalLayout ? "100%" : "auto"
  }),
  hr: {
    borderColor: "currentColor",
    borderStyle: "solid",
    borderWidth: "1px 0 0 0",
    opacity: 0.1
  },
  label: {
    color: "#aaa",
    textTransform: "uppercase",
    fontSize: "80%",
    margin: ".5em 0",
    display: "block",
    fontWeight: 600,
    letterSpacing: ".2em",
    textAlign: "left",
    flex: "1 1 40%"
  }
}



// WEBPACK FOOTER //
// ./src/components/summary/index.jsx